import styles from "./Success.module.css";
import Modal from "../../UI/Modal";
import mailIcon from "../../../assets/icons/mail.png";

export default function Success() {
    return (
        <Modal>
            <div className={styles[`container`]}>
                <div className={styles.title}>
                    <img src={mailIcon} className={styles.icon} />
                    Zahvaljujemo se na upitu. Javiti ćemo Vam se uskoro.
                </div>
                <div
                    className={styles.button}
                    onClick={() => {
                        window.location.href = "https://www.gtnet.hr/";
                    }}
                >
                    Povratak
                </div>
            </div>
        </Modal>
    );
}
